export function isFieldExcludedFromLayout(
  key: string,
  layoutFieldIds: Set<string> | undefined
): boolean {
  return Boolean(layoutFieldIds && !layoutFieldIds.has(key));
}
